import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { ICompany } from '@nxsys/types/models/company';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppInput from '@nxsys/components/AppInput';
import { Form, Row, Col } from 'antd';
import { useImperativeHandle, Ref, useEffect, useState } from 'react';

type VeriPayeSettingsFormRef = {
  submit: () => void;
};

export type VeriPayeSettingsFormValues = {
  clientId: string;
  accessKey: string;
  secretKey: string;
  bucketName: string;
};

type VeriPayeSettingsFormProps = {
  companyData?: ICompany;
  formRef?: Ref<VeriPayeSettingsFormRef>;
  onSubmit?: (values: VeriPayeSettingsFormValues) => void;
};

const VeriPayeSettingsForm: React.FC<VeriPayeSettingsFormProps> = ({
  companyData,
  formRef,
  onSubmit,
}) => {
  const { messages } = useTypedIntl();
  const [form] = Form.useForm();
  const [needReinitializeForm, setNeedReinitializeForm] = useState(true);

  useImperativeHandle(formRef, () => ({
    submit: () => {
      form.submit();
    },
  }));

  const onFinish = (values: any) => {
    onSubmit?.(values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error('Failed:', errorInfo);
  };

  useEffect(() => {
    if (companyData?.veriPayeSettings && needReinitializeForm) {
      const initialValues = {
        clientId: companyData.veriPayeSettings.clientId || '',
        accessKey: companyData.veriPayeSettings.accessKey || '',
        secretKey: companyData.veriPayeSettings.secretKey || '',
        bucketName: companyData.veriPayeSettings.bucketName || '',
      };
      form.setFieldsValue(initialValues);
      setNeedReinitializeForm(false);
    }
  }, [companyData?.veriPayeSettings]);

  return (
    <AppFormContainer
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
    >
      <Row gutter={24}>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.clientId']}
            name="clientId"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.bucketAccessKey']}
            name="accessKey"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.bucketSecretKey']}
            name="secretKey"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.bucketName']}
            name="bucketName"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
      </Row>
    </AppFormContainer>
  );
};

export default VeriPayeSettingsForm;
